import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {connectStream} from './../../lib/bastetjs/utils/connectStream';
import _ from 'lodash';

import {ControlFactory} from '../../utils/ControlFactory';
import {DialogModal} from './common/DialogModal';
import {
  saveEventToCalendar,
  removeEventFromCalendar
} from '../../data/StartListStreams';
import {getEventOptions} from '../../data/EventStreams';
import { Button } from '../shared/Button'
import {EventCalendarForm} from '../eventCalendar/EventCalendarForm';
import {getModalState, modal} from '../../data/ModalsStream';
import {Loading} from '../shared/Loading';
import { getStartListUrl } from '../../utils/startListHelpers';
import {setFilterValues} from '../shared/Filters';
import {colors} from '../../shared/styles';
import { trackGoogleEvent } from '../../utils/googleEvents';

const style = {
  loadingContainer: {
    display: 'inline-block',
    height:  50,
    width: 130,
    borderRadius: '3px',
    textAlign: 'center',
    opacity: 0.8,
  },
  loadingPosition:{
    display: 'inline-block',
    height: 24,
  },
};

class EventCalendarComponent extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    eventName: PropTypes.string,
    open: PropTypes.bool,
    hasFutureDate: PropTypes.bool,
    masterId: PropTypes.number.isRequired,
    events: PropTypes.array,
    buttonStyle: PropTypes.object,
    afterAdd: PropTypes.func,
    raceGoals: PropTypes.string,
    goalTime: PropTypes.number,
    canEditEvent: PropTypes.bool,
    isStarter: PropTypes.bool.isRequired,
    t: PropTypes.func
  };

  static defaultProps = {
    open: false,
    hasFutureDate: true,
    buttonStyle: {},
    afterAdd: () => {},
    canEditEvent: false
  };

  static modalName = 'event-calendar';

  state = {
    data: {
      validInput: true,
      EventID: this.props.eventId,
      CourseID: this.props.courseId,
      EventCourseID: this.props.eventCourseId
    },
    loading: false
  };

  constructor(props) {
    super(props);
    this.control = ControlFactory.get(this, {isMobile: props.isMobile});
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleRequestClose() {
    const {eventId, eventCourseId} = this.props;

    this.setState({
      loading: false
    });

    setFilterValues('event-start-list', {eventId, eventCourseId, sortByValue: 'goalTime'});

    modal.close(EventCalendarComponent.modalName);
  }

  handleTouchTap() {
    trackGoogleEvent('Claim', 'Click', 'Start List');
    const {hasFutureDate, masterId} = this.props;
    if (hasFutureDate) {
      modal.open(EventCalendarComponent.modalName);
    }
    else {
      this.props.history.push(`/event/${masterId}/startList/create`);
    }
  }

  handleChange(data) {
    const newData = _.assign(
      {},
      this.state.data,
      'EventID' in data ? {EventID: data.EventID} : {},
      'EventCourseID' in data ? {EventCourseID: data.EventCourseID} : {},
      'CourseID' in data ? {CourseID: data.CourseID} : {},
      'TargetTime' in data ? {TargetTime: data.TargetTime} : {},
      'RaceGoals' in data ? {RaceGoals: data.RaceGoals} : {},
      'validInput' in data ? {validInput: data.validInput} : {}
    );

    this.setState({
      data: newData
    });
  }

  render() {
    const {
      isMobile,
      eventName,
      open,
      masterId,
      events,
      eventId,
      courseId,
      eventCourseId,
      raceGoals,
      goalTime,
      isEdit = false,
      courses,
      canEditEvent,
      isStarter,
      isDarkButton,
      t
    } = this.props;

    const { loading, data } = this.state;

    const submitDisabled = !data.validInput || !eventId || !eventCourseId || loading;

    const modalButtonConfirm = {
      backgroundColor: submitDisabled ? colors.lightGrey4 : colors.blue,
      boxShadow: '0 0 0',
      fontFamily: 'ProximaNovaRegular',
      fontSize: 16,
      height: 40,
      margin: '0px 20px 0px 0px',
      marginRight: 6,
      minWidth: 100,
      paddingBottom: 10,
      width: 150,
      '&:hover': {
        backgroundColor: '#149fdd',
        boxShadow: '0 0 0'
      }
    };

    const modalButtonClose = {
      backgroundColor: '#fff',
      color: '#414141',
      fontFamily: 'ProximaNovaRegular',
      fontSize: 16,
      height: 40,
      margin: '0px 20px 0px 0px',
      marginRight: 6,
      minWidth: 100,
      paddingBottom: 10,
      width: 150,
      '&:hover': {
        color: colors.black,
        backgroundColor: colors.snow
      }
    };

    const ModalButtonNoLongerRacing = {...modalButtonClose, width: 220};

    const modalH1 = {
      color: '#4a4a4a',
      float: 'left',
      fontFamily: 'ProximaNovaRegular',
      fontSize: 34,
      lineHeight: '37px',
      marginBottom: '10px',
      marginTop: '10px',
      width: '100%',
    };

    const contentStyle = {
      minWidth: '800px',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    };

    const loadingButton =
      <div style={style.loadingContainer}>
        <div style={style.loadingPosition}>
          <Loading timeoutMessage={t('Still thinking...')}/>
        </div>
      </div>;

    const standardActions = (
      <div style={{padding: '20px 40px 40px 35px', textTransform: 'capitalize', width: '100%'}}>
        {
          isEdit && isStarter && !loading ?
            <div style={{float: 'left'}}>
              <Button
                id='no-longer-racing'
                style={ModalButtonNoLongerRacing}
                text={'NO LONGER RACING'}
                onClick={() => this.setState({loading: true}, () => this.removeFromCalendar())}
                variant={'text'}
              />
            </div>
          :
          isEdit && loading &&
            <div style={{float: 'left', marginTop: '10px'}}>
              {loadingButton}
            </div>
        }
        {
          loading && !isEdit ?
            loadingButton
          :
            <div style={{float: 'right'}}>
              <Button
                className='submit'
                style={modalButtonConfirm}
                text={'SUBMIT'}
                disabled={submitDisabled}
                onClick={() => this.setState({loading: true}, () => this.saveCalendar())}
              />
            </div>
        }
        <div style={{float: 'right'}}>
          <Button
            className='cancel-button'
            style={modalButtonClose}
            text={'CANCEL'}
            onClick={this.handleRequestClose}
            variant={'text'}
          />
        </div>
      </div>
    );

    return (
        !_.isEmpty(events) &&
        <span style={{ width: !isMobile? '100%' : 'auto' }}>
          <DialogModal
            title={<h1 style={modalH1} className='event-name-title'>{this.props.eventName}</h1>}
            separator={false}
            contentStyle={contentStyle}
            body={
              <EventCalendarForm
                id='add-yourself'
                courses={courses}
                isMobile={isMobile}
                masterId={masterId}
                events={events}
                eventName={eventName}
                eventId={eventId}
                courseId={courseId}
                eventCourseId={eventCourseId}
                raceGoals={raceGoals}
                goalTime={goalTime}
                onChange={this.handleChange}
                isEdit={isEdit}
                loading = {loading}
                canEditEvent={canEditEvent}
                isStarter={isStarter}
                isDarkButton={isDarkButton}
              />
            }
            actions={standardActions}
            open={open}
            onRequestClose={this.handleRequestClose}
            isMobile={this.props.isMobile}
          />
          {
            ControlFactory.get(this, {
              isMobile,
              loggedInStarter: isStarter
            })
          }
        </span>
    );
  }

  saveCalendar = async (CoursePatternID = 0) => {
    const {data} = this.state;
    const eventId = data.EventID;
    const eventCourseId = data.EventCourseID;
    const saveEventToCalendarStream = await saveEventToCalendar(data);

    return saveEventToCalendarStream.subscribe(() => {
      this.props.afterAdd({EventID: eventId, EventCourseID: eventCourseId, CoursePatternID});
      this.handleRequestClose();

      this.props.history.push({
        pathname: getStartListUrl(
          this.props.masterId, eventId, eventCourseId)
      });
    });
  };

  removeFromCalendar = async () => {
    const {data} = this.state;
    const removeEventFromCalendarStream = await removeEventFromCalendar(data);

    return removeEventFromCalendarStream.subscribe(() => {
      this.props.afterAdd({EventID: data.EventID, EventCourseID: data.EventCourseID});
      this.handleRequestClose();
    });
  }
}


export const EventCalendar = withTranslation()(connectStream({
  open: () => getModalState('event-calendar'),
  events: ({masterId}) => getEventOptions(masterId)
})(withRouter(EventCalendarComponent)));




/** WEBPACK FOOTER **
 ** ./components/modal/EventCalendar.js
 **/